document.addEventListener('alpine:init', () => {

  /**
   * This function is resposible for 
   * 1. Manage auto pagination on scroll down 
   * 2. Scroll back to selected product when navigating back to collection page from PDP.
   */
  
  Alpine.data('productsPagination', (productsPerPage) => ({
    showSortDropdown: false,
    baseURL: null,
    paginationElement: null,
    containerElement: null,
    nextPageLinkElement: null,
    urlParams: {},
    currentPage: 1,
    isLoading: false,
    isBackFromPDP: false, 
    queryString: null,
    scrollInitiated: false,
    loadNumber: 0, // Load number used to stop previous loading loop on new loop starts when applying filter
    settings: {
      offset: 0,
      container: '#product_grid',
      pagination: '#product_pagination',
      loadingText: 'Loading More...'
    },
    loadingPreviousPages: 0,
    nextPageResponceInAdvance: [],

    init() {

      this.setURLParams();
      this.baseURL = window.location.origin + window.location.pathname;
      this.loadPages();

      this.setPaginationObserver();

      this.paginationElement = this.$refs.pagination;
      this.containerElement = this.$refs.container;

      // Check if position has to move
      const scrollPosition = window.sessionStorage.getItem('LIF-PARAMS--PAGE-SCROLL-Y');
      const queryPosition = window.sessionStorage.getItem('LIF-PARAMS--QUERY-POSITION');
      if (scrollPosition || queryPosition) {
        this.isBackFromPDP = true;
      }

      this.$watch('reloadTrigger', () => {
        this.loadPages();
      });

      setTimeout(() => {
        // document.addEventListener('scroll', this.checkIfPaginationInView.bind(this));
        document.addEventListener('scroll', this.saveScrollPosition.bind(this));

        // Load more one page in advance
        this.nextPageLinkElement = this.paginationElement.querySelector('a');
      }, 1000); // This avoid scroll immedeatly after back from PDP

      // Load previous pages if page parameter is passed

      // Scroll to itme's position
      setTimeout(() => {
        // console.log('eweweweweeeeeeeeeeeeeeeeeeeeeeeeee');
        // this.checkIfPaginationInView.bind(this);

        // let's remove this until collection smooth issue resolve
        // this.scrollToSeeItem();
      }, 1000); // let's wait to load content/images to make scroll perfect

      // Load all previous pages
      // setTimeout(async () => {
      //   this.loadingPreviousPages = this.currentPage;
      //   for (i = parseInt(this.currentPage) - 1; i > 0; i--) {
      //     console.log('Loading previous page '+ i +'...');
      //     await this.loadPreviousPage(i);
      //     this.loadingPreviousPages = i;
      //   }

      //   this.loadingPreviousPages = 0;
      // }, 100); // Let's wait to sync current page

      // Track loading previous pages
      // this.$watch('loadingPreviousPages', () => {

        // let's remove this until collection smooth issue resolve
        // Reduce placeholder height once previous page is loaded.
        // const heightPerRow = 600;
        // const heightPerPage = heightPerRow * (productsPerPage / 4);
        // const previousPagesHeight = this.loadingPreviousPages * heightPerPage;
        // this.$refs.previousPagePlaceholder.style = `--placeholder-height: ${previousPagesHeight}px`;
      // });
    },

    get additionalQueryString() {
      return Alpine.store('collection').additionalQueryString;
    },

    get reloadTrigger() {
      return Alpine.store('collection').reloadTrigger;
    },

    setPaginationObserver() {
      const intersectionCallback = (entries, observer) => {
        if (!Alpine.store('collection').hasNextPage) {
          console.log('No more next page.');
          return;
        }

        console.log('intersectionCallback: ');
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            console.log('Load next is reached. Loading next page...');

            // Load next page
            this.loadMore();
          }
        });
      };

      const observer = new IntersectionObserver(intersectionCallback);
      const target = document.querySelector("#product_pagination");
      observer.observe(target);

      // console.log('----------------------- target: ');
      // console.log(target);

      // initially load next page in advance
      // this.loadMore();
    },
    async loadPreviousPage(page) {
      return new Promise((resolve, reject) => {
        fetch(this.baseURL+'?page='+page)
        .then((res) => res.text())
        .then((res) => {
          // console.log(res);

          // Initialize the DOM parser
          var parser = new DOMParser();

          // Parse the text
          const doc = parser.parseFromString(res, "text/html");

          const newContainer = doc.querySelectorAll(this.settings.container)[0];

          // render previous page content before current page
          this.containerElement.insertAdjacentHTML('afterbegin', newContainer.innerHTML);

          resolve();
        })
        .catch((error) => {
          console.error(error);
        });
      });
    },

    saveScrollPosition() {
      // This won't affect scrolls so skip
      if (window.scrollY < 100) {
        return;
      }

      // Collect scroll info
      const pageScrollInfo = JSON.stringify({
        URL: this.baseURL,
        POSITION: window.scrollY,
      });

      window.sessionStorage.setItem('LIF-PARAMS--PAGE-SCROLL-Y', pageScrollInfo);
    },

    /* We are no more using this, we are using intersect observer instead
    checkIfPaginationInView() {

      if (!Alpine.store('collection').hasNextPage) {
        return;
      }

      // Get top and bottom position with respect to pagination element
      const top = this.paginationElement.getBoundingClientRect().top - this.settings.offset;
      const bottom = this.paginationElement.getBoundingClientRect().bottom + this.settings.offset;

      // console.log(`Top: ${top}, Bottom: ${bottom}`);

      // Check if next page is already loading
      if (!this.isLoading && top <= window.innerHeight && bottom >= 0) {

        console.log('Going to load next page...');

        this.nextPageLinkElement = this.paginationElement.querySelector('a');

        if (this.nextPageLinkElement) {
          // this.nextPageLinkElement.innerText = this.settings.loadingText;
          this.loadMore();
        } else {
          Alpine.store('collection').hasNextPage = false;
        }
      }
    },
    */
    setURLParams() {
      const nextPageURL = this.nextPageLinkElement ? this.nextPageLinkElement.href : window.location.href;

      // Collect browser's parameter
      let params = new URL(nextPageURL).searchParams;
      params.forEach((value, key) => {
        this.urlParams[key] = value;

        if (key === 'page') {
          // this.currentPage = value;
        }
      });

      setTimeout(() => {
        // this.setPageInBrowserURL();
      }, 100); // Let's wait to sync above params
    },
    async loadPages(queryString = null) { // queryString is passed when filter is applied

      this.loadNumber += 1; // Load number used to stop previous loading loop on new loop starts when applying filter

      if (!queryString) {
        queryString = Object.entries(this.urlParams)
        .map(([key, val]) => `${key}=${val}`)
        .join('&');
      }

      this.queryString = queryString;
      let currentPage = 2; // Started from page 2

      // Reset current page
      this.currentPage = 1;
      
      Alpine.store('collection').hasNextPage = true;
      // this.nextPageResponceInAdvance = [];

      let hasNextPage = true;
      const thisLoadNumber = this.loadNumber;
      do {

        this.isLoading = true;

        // const nextPageURL = this.nextPageLinkElement.href;
        let nextPageURL = this.baseURL + '?page='+currentPage;

        if (this.queryString) {
          nextPageURL += `&${this.queryString}`;
        }

        if (this.additionalQueryString) {
          nextPageURL += `&${this.additionalQueryString}`;
        }

        // Check if page is already loading
        const nextPageResponse = this.nextPageResponceInAdvance.find(n => n.url == nextPageURL);
        if (nextPageResponse) {
          console.log('Page already loaded: '+nextPageURL);
          currentPage += 1;
          continue;
        }
        
        // console.log('Loading page URL: '+nextPageURL);

        const r = await fetch(nextPageURL);
        const res = await r.text();

        const parser = new DOMParser();

        // Parse the text
        const doc = parser.parseFromString(res, "text/html");

        // Fetch page content and pagination content from page result
        const newContainer = doc.querySelectorAll(this.settings.container)[0];
        const newPagination = doc.querySelectorAll(this.settings.pagination)[0];

        // Let's keep max cache size limit to 20
        if (this.nextPageResponceInAdvance.length == 20) {
          // Release oldest one, Delete item at index 0
          this.nextPageResponceInAdvance.shift();
        }

        if (typeof newPagination === 'undefined' || !newContainer || newContainer.innerHTML.trim() == '') {
          hasNextPage = false;
        } else {
          this.nextPageResponceInAdvance.push({ 
            url: nextPageURL,
            newContainer, 
            newPagination
          });
        }

        currentPage += 1;
       
      } while(hasNextPage && thisLoadNumber === this.loadNumber);

      if (thisLoadNumber === this.loadNumber) {
        this.isLoading = false;
      }
    },
    loadMore() {

      // const nextPageNumber = 'page_'+(this.currentPage + 1);
      const nextPageNumber = this.currentPage + 1;

      let nextPageURL = this.baseURL + '?page='+nextPageNumber;

      if (this.queryString) {
        nextPageURL += `&${this.queryString}`;
      }

      if (this.additionalQueryString) {
        nextPageURL += `&${this.additionalQueryString}`;
      }

      console.log('loadMore() Loading nextPageURL: '+nextPageURL);

      const nextPageResponse = this.nextPageResponceInAdvance.find(n => n && n.url == nextPageURL);

      // Check if previous request is still in progress, try after 2 second
      if (!nextPageResponse) {
        console.log('nextPageNumber not existing...'+nextPageNumber);

        if (this.isLoading) {
          setTimeout(() => {
            console.log('Recalling loadMore() after 1 second')
            this.loadMore();
          }, 1000);

          return false;
        } else {
          Alpine.store('collection').hasNextPage = false;
        }
      }

      // Process advance page response to make smooth and load faster
      if (nextPageResponse) {
        // Initialize the DOM parser
        // var parser = new DOMParser();

        // // Parse the text
        // const doc = parser.parseFromString(this.nextPageResponceInAdvance, "text/html");

        // Fetch page content and pagination content from page result
        // const newContainer = doc.querySelectorAll(this.settings.container)[0];
        // const newPagination = doc.querySelectorAll(this.settings.pagination)[0];

        const thisPage = nextPageResponse;

        if (thisPage.newContainer && this.containerElement) {
          // Render page content to end of the page
          this.containerElement.insertAdjacentHTML('beforeend', thisPage.newContainer.innerHTML);
        }

        if (typeof thisPage.newPagination === 'undefined' || !thisPage.newContainer || thisPage.newContainer.innerHTML.trim() == '') {
          Alpine.store('collection').hasNextPage = false;
        } else {
          this.paginationElement.innerHTML = thisPage.newPagination.innerHTML;
          this.currentPage += 1;
        }

        // Update next page parameter
        // this.setURLParams();
      } else {
        console.log('nextPageResponceInAdvance not exist yet for page '+nextPageNumber+'...');
      }
    },
    setPageInBrowserURL() { // Show page number on URL

      const newParams = { ...this.urlParams, page: this.currentPage };

      if (newParams.page == '1') {
        delete newParams.page; // No need to show 'page=1'
      }

      // Make url params
      const urlParams = Object.entries(newParams)
        .map(([key, val]) => `${key}=${val}`)
        .join('&');

      window.history.replaceState(newParams, document.title, urlParams ? `${this.baseURL}?${urlParams}` : this.baseURL);
    },
    gotoPDP(link, itemIndex) {
      this.saveQueryPosition(itemIndex);
      window.location.href = link;
    },
    saveQueryPosition(itemIndex) {
      // Calculate current page number
      this.currentPage = Math.ceil(itemIndex / productsPerPage);
      // this.setPageInBrowserURL();

      // Collect page scroll info
      const pageScrollInfo = JSON.stringify({
        URL: this.baseURL,
        INDEX: itemIndex,
      });
      console.log(pageScrollInfo);

      // Set page scroll info to session
      window.sessionStorage.setItem('LIF-PARAMS--QUERY-POSITION', pageScrollInfo);
    },
    scrollToSeeItem() {

      let isScrolled = false;

      // Check if scroll position set
      const scrollPosition = window.sessionStorage.getItem('LIF-PARAMS--PAGE-SCROLL-Y');
      if (scrollPosition) {
        const position = JSON.parse(scrollPosition);

        // Check if scroll position is available for current collection
        if (this.baseURL === position.URL) {
          if (position.POSITION < 100) { // Ignore is scroll position is upto 100
            position.POSITION = 0;
          }
          console.log(`Window is scrolling to position new: ${position.POSITION}`);
          // window.scrollTo(0, position.POSITION);

          this.scrollInitiated = true; // Indicator so show all product tiles
          isScrolled = true;

          setTimeout(() => {
            // Scroll window smoothly
            window.scrollTo({
              top: position.POSITION,
              behavior: 'smooth',
            })
          }, 100);
        }

        // Remove scroll position from session
        window.sessionStorage.removeItem('LIF-PARAMS--PAGE-SCROLL-Y');
      }

      if (!isScrolled) {
        // Check if scroll position for item
        const queryPosition = window.sessionStorage.getItem('LIF-PARAMS--QUERY-POSITION');
        if (queryPosition) {
          const position = JSON.parse(queryPosition);

          // Check if scroll position is available for current collection
          if (position.URL = this.baseURL) {
            const element = document.getElementById('cart_item_'+position.INDEX);
            
            console.log('Scrolling item: ');
            console.log(element);

            if (element) {
              // Scroll to see item
              console.log('Scrolling to see item.');

              this.scrollInitiated = true; // Indicator so show all product tiles

              setTimeout(() => {
                element.scrollIntoView();
              }, 1000);
            } else {
              console.log('Scrolling element not found.');
            }
          }

          // Remove scroll position from session
          window.sessionStorage.removeItem('LIF-PARAMS--QUERY-POSITION');
        } else {
          console.log('QUERY-POSITION not found.');
        }
      }

      // Remove scroll position from session
      window.sessionStorage.removeItem('LIF-PARAMS--QUERY-POSITION');
    },
    loadAllPages(cb) {
      // Check if all page is loaded
      if (this.isLoading) {
        setTimeout(() => {
          console.log('Recalling loadAllPages() after 1 second')
          this.loadAllPages(cb);
          return false;
        }, 1000);
      } else {
        // Load all pages
        do {
          this.loadMore();
        } while(Alpine.store('collection').hasNextPage);

        cb();
      }
    }
  }));
});